import {
    CONFIRMED_GET_OBJECTION,
    CONFIRMED_CREATE_OBJECTION,
    CONFIRMED_DELETE_OBJECTION,
    CONFIRMED_EDIT_OBJECTION
} from "../types/ObjectionTypes";


const initialState = {
    list: [],
    num_rows: 0,
};

export default function ObjectionReducer(state = initialState, action) {
    switch (action.type) {
        case CONFIRMED_GET_OBJECTION:
            return {
                ...state,
                list: action.payload.list,
                num_rows: action.payload.num_rows,
            };

        case CONFIRMED_CREATE_OBJECTION:
            return {
                ...state,
                list: [...state.list, action.payload],
            };

        case CONFIRMED_DELETE_OBJECTION:
            return {
                ...state,
                list: state.list.filter(
                    (item) =>
                        item.objection_id !== action.payload.objection_id
                ),
            };

        case CONFIRMED_EDIT_OBJECTION:
            const updatedList = [...state.list];
            const index = updatedList.findIndex(
                (item) =>
                    item.objection_id === action.payload.objection_id
            );

            if (index !== -1) {
                updatedList[index] = action.payload;
            }

            return {
                ...state,
                list: updatedList,
            };

        default:
            return state;
    }
}
